<template>
  <div class="footer-section">
    <p class="business-details">
      사업자등록번호 308-11-65295 | 대표: 김민아
    </p>
    <p class="business-details">
      통신판매신고 제 2025-서울강남-06709 호
    </p>
    <p class="business-details">
      주소: 서울특별시 강남구 삼성로 212, 18층 412호
    </p>
    <p class="business-details">
      사업자명: 인터루드 (Interlude) | 서비스명: Youngpro
    </p>
    <p class="business-details">
      번호: 010.3918.8151 | 이메일: info@youngpro.club
    </p>

    <div class="legal-header" @click="toggleLegalLinks">
      <h4><span class="toggle-icon">{{ isLegalLinksVisible ? '▼' : '▶' }}</span> 인터루드 기본약관</h4>
    </div>

    <div class="legal-links" v-show="isLegalLinksVisible">
      <span class="legal-link" :class="{ active: currentPage === 'terms' }" @click="goToTerms">이용약관</span>
      <span class="separator">|</span>
      <span class="legal-link" :class="{ active: currentPage === 'refund' }" @click="goToRefundPolicy">환불정책</span>
      <span class="separator">|</span>
      <span class="legal-link" :class="{ active: currentPage === 'privacy' }" @click="goToPrivacyPolicy">개인정보처리방침</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterDefault',
  props: {
    currentPage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLegalLinksVisible: false
    };
  },
  methods: {
    goToTerms() {
      this.$router.push('/terms-of-service');
    },
    goToRefundPolicy() {
      this.$router.push('/refund-policy');
    },
    goToPrivacyPolicy() {
      this.$router.push('/privacy-policy');
    },
    toggleLegalLinks() {
      this.isLegalLinksVisible = !this.isLegalLinksVisible;
    }
  }
};
</script>

<style scoped>
.footer-section {
  color: var(--text-primary);
  padding: 20px 20px 20px;
  border-top: 1px solid var(--hairline);
  text-align: center;
  background-color: var(--bg);
  border-top: 1px solid var(--card-border);
}

.legal-links {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.legal-link {
  font-size: 12px;
  color: var(--text-tertiary);
  cursor: pointer;
  transition: color 0.3s ease;
  text-decoration: underline;
}

.legal-link:hover {
  color: var(--accent-strong);
}

.legal-link.active {
  color: var(--accent-strong);
  text-decoration: none;
}

.separator {
  font-size: 12px;
  color: var(--text-secondary);
  margin: 0 4px;
}

.legal-header {
  margin: 20px 0;
  cursor: pointer;
  user-select: none;
}

.legal-header h4 {
  font-size: 16px;
  color: var(--text-primary);
  margin: 0;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.toggle-icon {
  font-size: 12px;
  transition: transform 0.2s ease;
}

.legal-header:hover h4 {
  color: var(--accent-strong);
}

.reference-note {
  font-size: 12px;
  color: var(--text-secondary);
  margin: 15px 0;
  font-style: italic;
}

.copyright-section {
  margin: 30px 0;
  padding: 20px 0;
  border-top: 1px solid var(--hairline);
}

.copyright-text {
  font-size: 14px;
  color: var(--text-primary);
  font-weight: 600;
  margin-bottom: 10px;
}

.business-details {
  font-size: 12px;
  color: var(--text-tertiary);
  margin: 5px 0;
  line-height: 1.4;
}

.toss-services {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid var(--hairline);
}

.toss-services h4 {
  font-size: 14px;
  color: var(--text-primary);
  margin: 0 0 15px 0;
  text-align: left;
}

.service-links {
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  flex-wrap: wrap;
}

.service-link {
  font-size: 12px;
  color: var(--text-tertiary);
  cursor: pointer;
  transition: color 0.3s ease;
  text-decoration: underline;
}

.service-link:hover {
  color: var(--accent-strong);
}
</style>
